import icons from '../assets/svg';

export default Object.keys(icons).reduce((res, key) => {
  res[key] = key;
  return res;
}, {});
